var _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPageRecipe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 62,
    r: 62,
    fill: "url(#paint0_linear_20213_57688)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.4118 66.583C37.5246 65.7408 33 60.679 33 54.5588C33 47.8498 38.438 42.4118 45.1471 42.4118C47.0145 42.4118 48.7837 42.8337 50.3648 43.587C50.658 37.1381 55.9791 32 62.5 32C69.0209 32 74.342 37.1381 74.6352 43.587C76.2163 42.8337 77.9855 42.4118 79.8529 42.4118C86.562 42.4118 92 47.8498 92 54.5588C92 60.679 87.4754 65.7408 81.5882 66.583V87.5294C81.5882 89.446 80.0343 91 78.1176 91H46.8824C44.9657 91 43.4118 89.446 43.4118 87.5294C43.4118 85.6128 44.9657 84.0588 46.8824 84.0588H72.9118C73.8709 84.0588 74.6471 83.2818 74.6471 82.3235C74.6471 81.3652 73.8709 80.5882 72.9118 80.5882H46.8824C44.9657 80.5882 43.4118 79.0343 43.4118 77.1176V66.583Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20213_57688",
    x1: 62,
    y1: 0,
    x2: 62,
    y2: 124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37B06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#199251"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageRecipe);
export default __webpack_public_path__ + "static/media/page-recipe.54763336f15fa487c514ba5b8b34d425.svg";
export { ForwardRef as ReactComponent };